// Raqamli kataklar (narx, miqdor, summa, chegirma) fokus olganda ichidagi matn
// to'liq tanlanadi — Tab yoki sichqoncha bilan kirilganda "0" ni o'chirib
// o'tirmasdan darrov yangi qiymat yozish mumkin. Bitta global tinglovchi:
// alohida sahifa/komponentlarga tegmaydi, React state'ga aralashmaydi.
const isNumericInput = (el) => {
  if (!el || el.tagName !== 'INPUT' || el.readOnly || el.disabled) return false;
  if (el.type === 'number') return true;
  const mode = el.getAttribute('inputmode');
  return el.type === 'text' && (mode === 'decimal' || mode === 'numeric');
};

export function initSelectOnFocus() {
  document.addEventListener('focusin', (e) => {
    const el = e.target;
    if (!isNumericInput(el)) return;
    // Sichqoncha bosilganda brauzer mouseup'da tanlovni bekor qilib, kursorni
    // qo'yadi — shuni bir martalik to'sib qo'yamiz (keyingi bosish kursor qo'yadi).
    const keep = (ev) => ev.preventDefault();
    el.addEventListener('mouseup', keep, { once: true });
    setTimeout(() => el.removeEventListener('mouseup', keep), 400);
    // setTimeout — React fokusga javoban qiymatni (masalan MoneyInput'da "" → "0") qayta
    // chizib bo'lgach tanlaymiz, aks holda yangilanish tanlovni bekor qilib yuborardi.
    setTimeout(() => {
      if (document.activeElement !== el) return;
      try { el.select(); } catch { /* ba'zi input turlarida select() yo'q */ }
    }, 0);
  });
}

// Qidiruv kataklari uchun (matnli input'larga global tinglovchi qo'llanmaydi) — fokus
// olganda ichidagi matn tanlanadi, shunda yangi so'rovni darrov yozish mumkin.
// Ishlatilishi: <input onFocus={selectTextOnFocus} />
export function selectTextOnFocus(e) {
  const el = e.target;
  const keep = (ev) => ev.preventDefault();
  el.addEventListener('mouseup', keep, { once: true });
  setTimeout(() => el.removeEventListener('mouseup', keep), 400);
  setTimeout(() => {
    if (document.activeElement !== el) return;
    try { el.select(); } catch { /* ba'zi input turlarida select() yo'q */ }
  }, 0);
}
